<template>
  <b-container>
    <b-row>
      <b-col sm="12" md="10" lg="8">
        <h1>{{ $t("tracking.cargo.occurrenceEdit") }}</h1>
        <success-fade-alert ref="alert" :msg="alert.success" />
        <fade-alert-danger ref="danger" :msg="alert.error" />

        <b-row class="mb-3 ml-0">
          <router-link :to="getUrlBack">
            <b-button size="sm">{{ $t("geral.back") }}</b-button>
          </router-link>
        </b-row>
        <div v-if="permissions == 2">
          <b-row>
            <b-col sm="12" md="6" lg="6">
              <cargo-crud-kanban
                ref="cargoCrudData"
                :model="model"
                :modelstate="modelstate"
                :readonly="canEdit"
              >
              </cargo-crud-kanban>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <custom-value-occurrence
                :occurrenceId="model.statusNew"
                :items.sync="model.values"
                :readonly="canEdit"
              >
              </custom-value-occurrence>
            </b-col>
          </b-row>
        </div>
        <div v-else-if="permissions == 1">
          <b-row>
            <b-col sm="12" md="6" lg="12">
              <cargo-crud-kanban
                ref="cargoCrudData"
                :model="model"
                :modelstate="modelstate"
                :readonly="!canEdit"
              >
              </cargo-crud-kanban>
            </b-col>
          </b-row>
          <!-- {{model}} -->
          <b-row>
            <b-col>
              <custom-value-occurrence
                :occurrenceId="model.statusNew"
                :items.sync="model.values"
                :readonly="!canEdit"
                :modelstate="modelstate"
              >
              </custom-value-occurrence>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-button class="button" @click="save" :disabled="canSubmit">
                {{ $t("geral.save") }}
              </b-button>
            </b-col>
          </b-row>
        </div>

        <div v-if="permissions == 0">
          <h4>Você não possui acesso a edição desta esta carga</h4>
        </div>
      </b-col>
    </b-row>
    <!-- {{ model }} -->
    <!-- <pre class="language-json"><code>{{ model }}</code></pre> -->
    <!-- <pre class="language-json"><code>{{ model.occurrences }}</code></pre> -->
  </b-container>
</template>

<script>
import FadeAlertDanger from "@/components/FadeAlertDanger.vue";
import SuccessFadeAlert from "@/components/SuccessFadeAlert.vue";
export default {
  name: "CargoEdit",
  components: {
    FadeAlertDanger,
    SuccessFadeAlert,
    CustomValueOccurrence: () =>
      import(
        "@/components_rms/trackingShippingCompany/occurrenceType/CustomValueOccurrence.vue"
      ),
    CargoCrudKanban: () =>
      import("@/components_rms/tracking/cargo/CargoCrudKanban.vue"),
  },
  props: {
    id: String,
    companyId: String,
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Registro alterado com sucesso",
      },
      submitted: false,
      modelstate: {},
      model: {
        cargoActive: true,
        clientName: "",
        companyId: "",
        companyBranchName: "",
        dateAttendance: "",
        dateDeliveryForecast: "",
        destinationCityName: "",
        originCityName: "",
        status: 1,
        statusNew: 1,
        vehicleTypeName: "",
        weight: "0.00",
        values: [],
        cargoPath: [],
      },
      permissions: 0,
    };
  },
  mounted() {
    this.loadData();
  },
  created() {
    this.getPermision();
  },

  computed: {
    canEdit() {
      if (!this.model) {
        return false;
      }
      if (!this.model.cargoActive) {
        return true;
      }
      // if (this.model.status == 13) {
      //   return false;
      // }
      return true;
    },
    canSubmit() {
      if (this.submitted) {
        return true;
      }
      if (!this.canEdit) {
        return true;
      }
      return false;
    },
    getUrlBack() {
      return `../../cargo/kanban`;
    },
    getUrlCargoList() {
      if (this.companyId) {
        return `cargo/get/${this.id}/${this.companyId}`;
      }
      return `cargo/get/${this.id}`;
    },
    getUrlPermission() {
      return `v1/getOccurrencePermissions/${this.id}`;
    },
  },
  methods: {
    async loadData() {
      this.$api
        .get(this.getUrlCargoList)
        .then((response) => {
          let model = response.data;
          console.log(model);
          model.statusNew = 1;
          if (model.status == 13) model.status = 1;
          if (model.statusNew == 13) model.statusNew = 1;
          console.log("CargoKanbanEdit - response.data");
          console.log(response.data);
          // model.weight = model.weight.toFixed(2);
          this.model = model;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            if (error.response) {
              if (error.response.status == 400) {
                this.modelstate = error.response.data.errors;
              }
            }
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
    save() {
      this.submitted = true;
      this.$refs.cargoCrudData.dataFormat();
      console.log(this.model);

      this.$api
        .post(
          "/v1/cargo/occurrence/" + this.model.cargoId.toString(),
          this.model
        )
        .then((response) => {
          console.log(response);
          this.model = response.data;
          this.$refs.alert.show();
          this.modelstate = {};
          this.submitted = false;
          //   this.$router.push({ name: 'CargoKanban' });
          this.$router.push("../kanban");
        })
        .catch((error) => {
          console.log("error");
          console.log(error);

          this.submitted = false;
          this.modelstate = {};
          if (error.response) {
            console.log(error.response);
            console.log(error.response.data.errors);
            if (error.response.status == 400) {
              this.modelstate = error.response.data.errors;
              this.alert.error = error.message;
              this.$refs.danger.show();
            } else if (error.response.status == 500) {
              console.log(error.response);
              this.alert.error = error.response.data.detail;
              this.$refs.danger.show();
            } else if (error.response.status == 404) {
              this.alert.error = error.response.data.message;
              this.$refs.danger.show();
              console.log("ok");
            } else {
              this.alert.error = error.message;
              this.$refs.danger.show();
            }
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
    getPermision() {
      this.$api
        .get(this.getUrlPermission)
        .then((response) => {
          // console.log("entrou");
          // console.log(response.data.permissions);
          this.permissions = response.data.permissions;
          // console.log(this.permissions)
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
  },
  watch: {
    stateId() {
      this.loadData();
    },
  },
};
</script>
